import { render, staticRenderFns } from "./GuardianChangedYN.vue?vue&type=template&id=49d12c75"
import script from "./GuardianChangedYN.vue?vue&type=script&lang=js"
export * from "./GuardianChangedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports